(function () {
  var KEY = 'of-compare', MAX = 4;
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} render(); }
  function inList(h, l) { return (l || load()).some(function (p) { return p.handle === h; }); }
  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function isEn() { var b = document.getElementById('of-cmpbar'); return !!(b && b.dataset.en === '1'); }
  function toggle(d) {
    var l = load(), en = isEn();
    if (inList(d.handle, l)) {
      l = l.filter(function (p) { return p.handle !== d.handle; });
    } else {
      if (l.length >= MAX) {
        alert(en ? 'You can compare up to ' + MAX + ' products. Please remove one first.' : 'Es koennen maximal ' + MAX + ' Produkte verglichen werden. Bitte entferne zuerst eines.');
        return;
      }
      l.push(d);
    }
    save(l);
  }
  function render() {
    var l = load(), en = isEn();
    document.querySelectorAll('.of-cmp').forEach(function (b) {
      var on = inList(b.dataset.handle, l);
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var bar = document.getElementById('of-cmpbar');
    if (!bar) return;
    if (l.length === 0) { bar.className = ''; bar.innerHTML = ''; return; }
    var h = '<div class="thumbs">' + l.map(function (p) {
      return '<div class="t" style="background-image:url(\'' + esc(p.image) + '\')" title="' + esc(p.title) + '"><button type="button" data-rm="' + esc(p.handle) + '" aria-label="' + (en ? 'Remove' : 'Entfernen') + '">&times;</button></div>';
    }).join('') + '</div>';
    h += '<a class="btn btn-primary" href="' + (bar.dataset.url || '/pages/vergleich') + '">' + (en ? 'Compare' : 'Vergleichen') + ' (' + l.length + ')</a>';
    h += '<button type="button" class="clr" data-clear="1">' + (en ? 'Remove all' : 'Alle entfernen') + '</button>';
    bar.innerHTML = h;
    bar.className = 'show';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.of-cmp');
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      toggle({ handle: b.dataset.handle, title: b.dataset.title, image: b.dataset.image, price: b.dataset.price, url: b.dataset.url });
      return;
    }
    var rm = e.target.closest('[data-rm]');
    if (rm && !rm.closest('#of-cmp-table')) { save(load().filter(function (p) { return p.handle !== rm.dataset.rm; })); return; }
    if (e.target.closest('[data-clear]') && !e.target.closest('#of-cmp-table')) { save([]); }
  });
  window.OFCompare = { load: load, save: save, render: render };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', render); } else { render(); }
})();
